import React from "react";
import CommunityEditPage from "../community/components/CommunityEditPage";
import { IMMEDIATE_HELP } from "../community/constants";

export default function EditImmediateHelpPage() {
  return <CommunityEditPage section={IMMEDIATE_HELP} />;
}
